<template>
  <panel>
    <p slot="header">
      Dodaj administratora
    </p>
    <p slot="actions">
      <ui-button type="flat" icon="navigate_before" color="primary" @click="$router.push({name: 'admin.users.dashboard'})">Wróć do administratorów</ui-button>
    </p>
    <users-form :item="item"></users-form>
  </panel>

</template>
<script>
import Users from './../../services/Users'

export default {
  data () {
    return {
      item: Users.getBaseItem()
    }
  },
  mounted () {}
}
</script>


// WEBPACK FOOTER //
// Create.vue?fb5ff882